const detailItems = document.querySelectorAll('.dropdown-content')
const dropDown =  document.querySelectorAll('.dropbtn')

function showDropdownContent (e){
  detailItems.forEach(el => el.classList.add('hidden'))
  let dropdownContent = e.target.parentNode.querySelector('.dropdown-content')
  dropdownContent.classList.remove('hidden')
}

dropDown.forEach(element => {
  element.addEventListener('click', showDropdownContent)
})

// Close the dropdown if the user clicks outside of it
window.onclick = function(event) {
  if (!event.target.matches('.dropbtn')) {
    var dropdowns = document.getElementsByClassName("dropdown-content");
    var i;
    for (i = 0; i < dropdowns.length; i++) {
      var openDropdown = dropdowns[i];
      openDropdown.classList.add('hidden');
    }
  }
}
